import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [6.20347711581],
    [0.18656368093, 5.0503710027, 3340.6124266998],
    [0.01108216816, 5.40099836344, 6681.2248533996],
    [0.00091798406, 5.75478744667, 10021.8372800994],
    [0.00027744987, 5.97049513147, 3.523118349],
    [0.00012315897, 0.84956094002, 2810.9214616052],
    [0.00010610235, 2.93958560338, 2281.2304965106],
    [0.00008926784, 4.15697846427, 0.0172536522],
    [0.00008715691, 6.11005153139, 13362.4497067992],
    [0.00007774872, 3.33968761376, 5621.8429232104],
    [0.00006797556, 0.36462229657, 398.1490034082],
    [0.00004161108, 0.22814971327, 2942.4634232916],
    [0.00003575078, 1.6618650571, 2544.3144198834],
    [0.00003075252, 0.85696614132, 191.4482661116],
    [0.00002937546, 6.07893711402, 0.0673103028],
    [0.00002628117, 0.64806124465, 3337.0893083508],
    [0.00002579844, 0.02996736156, 3344.1355450488],
    [0.00002389414, 5.03896442664, 796.2980068164],
    [0.00001798806, 0.65634057445, 529.6909650946],
    [0.00001546404, 2.91579701718, 1751.539531416],
    [0.00001528141, 1.14979301996, 6151.533888305],
    [0.00001286228, 3.06796065034, 2146.1654164752],
    [0.00001264357, 3.62275122593, 5092.1519581158],
    [0.00001024902, 3.69334099279, 8962.4553499102],
    [0.00000891566, 0.18293837498, 16703.062133499],
    [0.00000858759, 2.4009381194, 2914.0142358238],
    [0.0000083272, 4.49495782139, 3340.629680352],
    [0.00000832715, 2.46418619474, 3340.5951730476],
    [0.00000748723, 3.82248614017, 155.4203994342],
    [0.00000723861, 0.67497311481, 3738.761430108],
    [0.00000712902, 3.66335473479, 1059.3819301892],
    [0.00000655162, 0.48864064125, 3127.3133312618],
    [0.00000635548, 2.92182225127, 8432.7643848156],
    [0.0000055275, 4.47479317037, 1748.016413067],
    [0.00000550474, 3.81001042328, 0.9803210682],
    [0.00000472167, 3.62547124025, 1194.4470102246],
    [0.00000425966, 0.55364317304, 6283.0758499914],
    [0.00000415131, 0.49662285038, 213.299095438],
    [0.00000312141, 0.99853944405, 6677.7017350506],
    [0.00000306551, 0.38052848348, 6684.7479717486],
    [0.00000302375, 4.48618007156, 3532.0606928114],
    [0.00000299395, 2.78323740866, 6254.6266625236],
    [0.00000293198, 4.22131299634, 20.7753954924],
];

const VSOP87_L1: Vsop87Element = [
    [3340.61242700512],
    [0.01457554523, 3.60433733236, 3340.6124266998],
    [0.00168414711, 3.92318567804, 6681.2248533996],
    [0.00020622975, 4.26108844583, 10021.8372800994],
    [0.00003452392, 4.7321039319, 3.523118349],
    [0.00002586332, 4.60670058555, 13362.4497067992],
    [0.00000841535, 4.45864030426, 2281.2304965106],
    [0.00000537567, 5.01581256923, 398.1490034082],
    [0.00000520948, 4.99428054039, 3344.1355450488],
    [0.00000432635, 2.56070853083, 191.4482661116],
    [0.00000429655, 5.31645299471, 155.4203994342],
    [0.00000381751, 3.53878166043, 796.2980068164],
    [0.0000032853, 4.95632685192, 16703.062133499],
    [0.00000282795, 3.15966768785, 2544.3144198834],
    [0.00000205657, 4.56889279932, 2146.1654164752],
    [0.00000168866, 1.3293655906, 3337.0893083508],
    [0.00000157593, 4.18519540728, 1751.539531416],
    [0.00000133686, 2.23327245555, 0.9803210682],
    [0.00000133565, 5.97420357518, 1748.016413067],
    [0.00000117503, 6.02411290806, 6151.533888305],
    [0.00000116965, 2.21414273762, 1059.3819301892],
    [0.00000113886, 2.12863726524, 1194.4470102246],
    [0.00000113718, 5.42753341019, 3738.761430108],
];

const VSOP87_L2: Vsop87Element = [
    [0.00058152577, 2.04961712429, 3340.6124266998],
    [0.00013459579, 2.45738706163, 6681.2248533996],
    [0.00002432575, 2.79737979284, 10021.8372800994],
    [0.00000451384],
    [0.00000401065, 3.13581149963, 13362.4497067992],
    [0.00000222025, 3.19437046607, 3.523118349],
    [0.00000120954, 0.54327128607, 155.4203994342],
    [0.00000062971, 3.47765178989, 16703.062133499],
];

const VSOP87_L3: Vsop87Element = [
    [0.00001467867, 0.4442983946, 3340.6124266998],
    [0.00000692668, 0.88679887123, 6681.2248533996],
    [0.00000189478, 1.28336839921, 10021.8372800994],
    [0.00000041615, 1.64210455567, 13362.4497067992],
];

const VSOP87_L4: Vsop87Element = [
    [0.00000027242, 5.6399774232, 6681.2248533996],
    [0.00000025511, 5.13956279086, 3340.6124266998],
];

const VSOP87_L5: Vsop87Element = [[0.00000000762, 4.03556368806, 6681.2248533996]];

const VSOP87_B0: Vsop87Element = [
    [0.03197134986, 3.76832042431, 3340.6124266998],
    [0.00298033234, 4.10616996305, 6681.2248533996],
    [0.00289104742],
    [0.00031365539, 4.4465105309, 10021.8372800994],
    [0.000034841, 4.7881254926, 13362.4497067992],
    [0.00000443401, 5.02642622964, 3344.1355450488],
    [0.00000442999, 5.65233014206, 3337.0893083508],
    [0.00000399109, 5.13056816928, 16703.062133499],
    [0.00000292506, 3.79290674178, 2281.2304965106],
];

const VSOP87_B1: Vsop87Element = [
    [0.00217310991, 6.04472194776, 3340.6124266998],
    [0.00012834709, 1.60810667915, 6681.2248533996],
    [0.00003320981, 2.62947004077, 10021.8372800994],
    [0.000006272, 3.11898601248, 13362.4497067992],
    [0.0000010199, 3.52113557592, 16703.062133499],
];

const VSOP87_B2: Vsop87Element = [
    [0.00008888446, 1.06196052751, 3340.6124266998],
    [0.00000918914, 0.1153843119, 6681.2248533996],
];

const VSOP87_B3: Vsop87Element = [[0.00000330418, 2.04215300484, 3340.6124266998]];

const VSOP87_B4: Vsop87Element = [];

const VSOP87_B5: Vsop87Element = [];

const VSOP87_R0: Vsop87Element = [
    [1.53033488271],
    [0.1418495316, 3.47971283528, 3340.6124266998],
    [0.00660776362, 3.81783443019, 6681.2248533996],
    [0.00046179117, 4.15595316782, 10021.8372800994],
    [0.00008109733, 5.55958416318, 2810.9214616052],
    [0.00007485318, 1.77239078402, 5621.8429232104],
    [0.00005523191, 1.3643630377, 2281.2304965106],
    [0.0000382516, 4.49407183687, 13362.4497067992],
    [0.00002484394, 4.9254563992, 2942.4634232916],
    [0.00002306537, 0.09081579001, 2544.3144198834],
    [0.00001999396, 5.36059617709, 3337.0893083508],
    [0.00001960195, 4.74249437639, 3344.1355450488],
    [0.00001167119, 2.11260868341, 5092.1519581158],
    [0.00001102816, 5.00908403998, 398.1490034082],
    [0.00000992252, 5.83861961952, 6151.533888305],
    [0.00000899066, 4.40791133207, 529.6909650946],
    [0.00000807354, 2.10217065501, 1059.3819301892],
    [0.00000797915, 3.44839203899, 796.2980068164],
    [0.00000740975, 1.49906336885, 2146.1654164752],
    [0.00000725583, 1.24516810723, 8432.7643848156],
    [0.00000692339, 2.13378874689, 8962.4553499102],
    [0.00000633144, 0.89353283242, 3340.5951730476],
    [0.0000063314, 2.92430446399, 3340.629680352],
    [0.00000629978, 1.28737486495, 1751.539531416],
    [0.00000574355, 0.82896244455, 2914.0142358238],
    [0.00000526166, 5.38292991236, 3738.761430108],
    [0.00000472775, 5.19850522346, 3127.3133312618],
];

const VSOP87_R1: Vsop87Element = [
    [0.01107433345, 2.03250524857, 3340.6124266998],
    [0.00103175887, 2.37071847807, 6681.2248533996],
    [0.000128772],
    [0.0001081588, 2.70888095665, 10021.8372800994],
    [0.0000119455, 3.04702256206, 13362.4497067992],
    [0.00000438582, 2.88835054603, 2281.2304965106],
    [0.000003957, 3.42323670971, 3344.1355450488],
    [0.00000182576, 1.58427562964, 2544.3144198834],
    [0.00000135851, 3.38507063082, 16703.062133499],
    [0.00000128362, 6.04343227063, 3337.0893083508],
    [0.00000128199, 0.62991771813, 1059.3819301892],
    [0.00000127059, 1.95391155885, 796.2980068164],
    [0.00000118443, 2.99762091382, 2146.1654164752],
    [0.00000087534, 3.42053385867, 398.1490034082],
];

const VSOP87_R2: Vsop87Element = [
    [0.00044242249, 0.47930604954, 3340.6124266998],
    [0.00008138042, 0.86998389204, 6681.2248533996],
    [0.00001274915, 1.22593985222, 10021.8372800994],
    [0.00000187388, 1.57298976045, 13362.4497067992],
    [0.00000040745, 1.97082077028, 3344.1355450488],
    [0.00000026617, 1.91665337822, 16703.062133499],
];

const VSOP87_R3: Vsop87Element = [
    [0.00001113108, 5.14987305093, 3340.6124266998],
    [0.00000424447, 5.61343952053, 6681.2248533996],
];

const VSOP87_R4: Vsop87Element = [];

const VSOP87_R5: Vsop87Element = [];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];
export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];
export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
